module.exports = __webpack_public_path__ + "media/out3.64535027.mp4";